/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Reports_Pdf_Generated_AtInputs */

const en_reports_pdf_generated_at = /** @type {(inputs: Reports_Pdf_Generated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generated on ${i?.date}`)
};

const pt_br2_reports_pdf_generated_at = /** @type {(inputs: Reports_Pdf_Generated_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gerado em ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Generated on {date}" |
*
* @param {Reports_Pdf_Generated_AtInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_pdf_generated_at = /** @type {((inputs: Reports_Pdf_Generated_AtInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Pdf_Generated_AtInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_pdf_generated_at(inputs)
	return pt_br2_reports_pdf_generated_at(inputs)
});